const resolveOfflineFlag = () => {
  if (typeof import.meta !== "undefined" && import.meta.env) {
    const value = import.meta.env.VITE_OFFLINE_SYNC_ENABLED;
    if (typeof value === "string") {
      return value !== "false" && value !== "0";
    }
  }
  if (typeof process !== "undefined" && process.env) {
    const value = process.env.VITE_OFFLINE_SYNC_ENABLED ?? process.env.OFFLINE_SYNC_ENABLED;
    if (typeof value === "string") {
      return value !== "false" && value !== "0";
    }
  }
  return true;
};

export const OFFLINE_SYNC_FEATURE_FLAG = "OFFLINE_SYNC_ENABLED";

export default {
  productionDbPrefix: "main",
  stagingDbPrefix: "staging",
  offlineSyncEnabled: resolveOfflineFlag(),
};
